import {
    putBillingCodeLoading,
    putBillingCodeRequest,
    putBillingCodeSuccess,
    putBillingCodeReject,
    putBillingCodeReset,
} from "../../actions/billingCode/put";

export const putBillingCode = (formData) => async (dispatch, getState) => {
    dispatch(putBillingCodeLoading());
    try {
        const { data } = await putBillingCodeRequest(formData, getState);
        dispatch(putBillingCodeSuccess(data))
    } catch (error) {
        dispatch(putBillingCodeReject(error))
    } finally {
        setTimeout(() => { dispatch(putBillingCodeReset()) }, 3000);
    }
    return Promise.resolve();
};
